/**
 * @module mapbs.components.reportpanel.liegenschaftskenndaten.liegenschaftskenndaten
 */

import angular from 'angular';

import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import olInteractionDraw from 'ol/interaction/Draw.js';
import olFormatWFS from 'ol/format/WFS.js';
import * as olFormatFilter from 'ol/format/filter.js';

import mapbsReportservice from 'mapbs/components/reportpanel/service/reportservice.js';
import mapbsLiegtypselect from 'mapbs/components/reportpanel/liegtypselect/liegtypselect.js';
import mapbsLiegtypselectobject from 'mapbs/components/reportpanel/liegtypselect/liegtypselectobject.js';

const moduleLiegenschaftskenndaten = angular.module('mapbsLiegenschaftskenndatenModule', [
    mapbsReportservice.name,
    mapbsLiegtypselect.name,
]);

moduleLiegenschaftskenndaten.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/Liegenschaftskenndaten',
            require('./liegenschaftskenndaten.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const LiegenschaftskenndatenComponent = {
    controller: 'mapbsLiegenschaftskenndatenController as ctrl',
    templateUrl: () => 'mapbs/Liegenschaftskenndaten',
    bindings: {
        'map': '<mapbsLiegenschaftskenndatenMap',
        'reportPanelActive': '<mapbsLiegenschaftskenndatenActive',
        'template': '@mapbsLiegenschaftskenndatenTemplate', // template / layout of print (see vars_yaml / case sensitive)
        'reporttitle': '@mapbsLiegenschaftskenndatenTitle',
    },
};

moduleLiegenschaftskenndaten.component(
    'mapbsLiegenschaftskenndaten',
    LiegenschaftskenndatenComponent
);

class LiegenschaftskenndatenController {
    /**
   * @constructor
   * @private
   * @param {angular.Scope} $scope
   * @param {angular.$http} $http
   * @param {angular.$injector} $injector
   * @param {Reportservice} mapbsReportservice
   * @param {ngeo.ToolActivateMgr} ngeoToolActivateMgr
   *
   * @ngInject
   */
    constructor(
        $scope,
        $http,
        $injector,
        mapbsReportservice,
        ngeoToolActivateMgr
    ) {
        this.scope = $scope;
        this.http = $http;
        this.reportservice = mapbsReportservice;

        /**@type {string} @private */
        this.mapservurl = $injector.get('mapserverUrl');

        /** @type {Array.<mapbsLiegtypselectobject>} */
        this.liegtypselec = [];

        /** @type {string} */
        this.state = 'inactive';

        /** @type {boolean}  */
        this.showmodal = false;

        /** @type {string}  */
        this.downloadurl = '';

        /** @type {string}  */
        this.errormessage = '';

        /** @type {boolean} */
        this.reportPanelActive;

        /** @type {string} */
        this.template;

        /** @type {string}  */
        this.reporttitle = 'Liegenschaftskenndaten';

        this.liegDrawinteraction = new olInteractionDraw({
            type: /** @type{import("ol/geom/GeometryType.js")} */ ('Point'),
        });

        this.liegDrawinteraction.on('drawend', (event) => {
            const coord = event.feature.getGeometry();
            this.setState('waitforprint');
            this.queryFeature(coord);
        });

        /** @type {boolean} */
        this.mapInteractionActive = false;

        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'aktive'),
            false
        );

        this.scope.$on('tookfocus', (event, name) => {
            if (name !== this.template) {
                this.setState('inactive');
            }
        });

        this.scope.$watch(
            () => {
                return this.reportPanelActive;
            },
            (newVal) => {
                if (!newVal) {
                    this.setState('inactive');
                }
            }
        );
    }

    /**
   * toggle state of component from 'active' to 'inactive' and vice versa
   */
    togglestate() {
        if (this.state === 'inactive') {
            this.setState('active');
        } else {
            this.setState('inactive');
        }
    }

    /** @private */
    setState(state) {
        this.map.removeInteraction(this.liegDrawinteraction);

        switch (state) {
            case 'active':
                this.scope.$emit('takefocus', this.template);
                this.map.addInteraction(this.liegDrawinteraction);
                this.mapInteractionActive = true;
                break;
            case 'waitforprint':
                // not yet deactivate mapInteractionActive
                break;
            default:
                this.mapInteractionActive = false;
                break;
        }

        this.state = state;
    }

    /**
   * @private
   */
    queryFeature(coord) {
        const body = new XMLSerializer().serializeToString(
            this.getFeatureRequestBody(coord)
        );
        const params = {};
        this.http
      .post(this.mapservurl, body, {
          params,
          headers: {'Content-Type': 'text/xml; charset=UTF-8'},
      })
      .then((response) => {
          const feat = new olFormatWFS().readFeatures(response.data);
          this.handleQueryFeatureResult(feat);
      });
    }

    /** @private */
    getFeatureRequestBody(coord) {
        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',

            featureTypes: [
                'BS_Liegenschaften_Grundstuecke_Liegenschaftsparzelle',
                'BS_Liegenschaften_Grundstuecke_Allmendparzelle',
                'BS_Liegenschaften_Grundstuecke_Unterbaurecht',
                'BS_Liegenschaften_Grundstuecke_Baurecht',
            ],
            filter: olFormatFilter.intersects('the_geom', coord),
        });

        return featureRequest;
    }

    /** @private */
    handleQueryFeatureResult(features) {
        if (features.length === 0) {
            this.info = 'Keine Daten gefunden';
        } //TODO translate
        if (features.length === 1) {
            this.startprint(features[0].get('bs_egrid'));
        } else {
            this.openLiegTypSelector(features);
        }
    }

    /** @private */
    openLiegTypSelector(featureList) {
        this.liegtypselec = [];
        featureList.forEach((f) => {
            const ltso = new mapbsLiegtypselectobject();
            ltso.typ = f.get('bs_art');
            ltso.sektion = f.get('bs_sektionnummer');
            ltso.parznr = f.get('bs_prznummer');
            ltso.egrid = f.get('bs_egrid');
            this.liegtypselec.push(ltso);
        });
        this.showmodal = true;
    }

    /**
   * handle selection of liegenschaft from ltsselector
   * @param {mapbsLiegtypselectobject} ltso
   */
    selectlts(ltso) {
        this.startprint(ltso.egrid);
    }

    /** @private */
    startprint(egrid) {
        this.map.removeInteraction(this.liegDrawinteraction);

        this.reportservice
      .createReport(this.template, egrid)
      .then(
          this.handleReportSuccess.bind(this),
          this.handleReportError.bind(this)
      );
    }

    /**
   * cancel the print report
   */
    cancelprint() {
        this.reportservice.cancelReport();
    }

    /** @private */
    handleReportSuccess(url) {
        this.downloadurl = url;
        this.setState('ready');
    }

    /** @private */
    handleReportError(error) {
        this.errormessage = error;
        this.setState('error');
    }

    /**
   * handle closing of ltsselector by user with the 'close' icon
   */
    closelts() {
        this.setState('active');
    }
}

moduleLiegenschaftskenndaten.controller(
    'mapbsLiegenschaftskenndatenController',
    LiegenschaftskenndatenController
);

export default moduleLiegenschaftskenndaten;
